// ── 출퇴근 관리 페이지 인라인 스타일 모음 ────────────────────────────────────
// CSS-in-JS 스타일 객체 (모든 컴포넌트에서 공유)

// ── 공통 버튼 ──────────────────────────────────────────────────────────────────
export const btn = {
  border: '1px solid var(--border)', borderRadius: 8, padding: '8px 10px',
  background: 'var(--bg-card)', cursor: 'pointer', fontWeight: 600, fontSize: 13, color: 'var(--text-sub)',
};
// 주요 액션 버튼 — 디자인 표준(직원 관리 기준, 2026-08-26): 파란색 → 검정
export const primaryBtn = { ...btn, background: 'var(--std-btn, #0f172a)', borderColor: 'var(--std-btn, #0f172a)', color: '#fff' };

// ── 공통 인풋 / 폼 ─────────────────────────────────────────────────────────────
// box-sizing/min-width 0 — 출퇴근 수정 모달 좌우 잘림 방지 (긴 주소 입력 시 부모 모달을 늘리던 원인)
export const inputStyle = {
  border: '1px solid var(--border)', borderRadius: 8, padding: '9px 12px',
  width: '100%', maxWidth: '100%', minWidth: 0, boxSizing: 'border-box',
  fontSize: 14, background: 'var(--bg-card)', color: 'var(--text)',
};
export const labelStyle  = { fontSize: 12, fontWeight: 600, color: 'var(--text-muted)', marginBottom: 4 };
// minWidth: 0 — grid 자식의 default min-width:auto가 콘텐츠 크기로 부모를 늘리는 것 차단
export const fieldStyle  = { display: 'grid', gap: 4, minWidth: 0 };
export const editFormStyle = { display: 'grid', gap: 10, minWidth: 0 };
// overflow-wrap/word-break — 긴 IP/별칭/주소 강제 줄바꿈
export const registeredBoxStyle = { border: '1px solid var(--border)', borderRadius: 8, padding: '10px 12px', background: 'var(--bg-subtle)', minWidth: 0, overflowWrap: 'anywhere', wordBreak: 'break-all' };
export const registeredListStyle = { margin: 0, paddingLeft: 18, display: 'grid', gap: 4, minWidth: 0 };

// ── 페이지 레이아웃 (연차 관리와 통일된 컴팩트 스펙, Phase 1-2) ──────────────
export const pageWrapStyle = { display: 'grid', gap: 10 };
/** 페이지 헤더 카드 */
export const pageHeaderCard = {
  background: 'var(--bg-card)', borderRadius: 12, border: '1px solid var(--border)',
  padding: '8px 14px',
};
export const pageTitleStyle = { margin: 0, fontSize: 16, fontWeight: 900, color: 'var(--text)' };
export const topRowStyle = { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8, flexWrap: 'wrap' };

// ── 필터 카드 ──────────────────────────────────────────────────────────────────
export const filterCardStyle = {
  background: 'var(--bg-card)', border: '1px solid var(--border)',
  borderRadius: 12, padding: '12px 14px',
};
/**
 * 필터 그리드 — auto-fit으로 화면 폭에 맞춰 열 수 자동 조절 (Phase 1-2 후속 개선)
 *  · 데스크탑: minmax(140px, 1fr) — 한 줄에 4~5개 입력 정렬
 *  · 모바일:   minmax(110px, 1fr) — 360px 폭 기준 [이름검색][연도][월] 한 줄,
 *              더 좁으면 자동 줄바꿈(2-up 폴백). 별도 분기 없이 동일 그리드 규칙.
 */
export const filterGridStyle = (isMobile) => ({
  display: 'grid',
  gridTemplateColumns: isMobile
    ? 'repeat(auto-fit, minmax(110px, 1fr))'
    : 'repeat(auto-fit, minmax(140px, 1fr))',
  gap: 8, alignItems: 'center',
});

// ── 모바일 카드 ────────────────────────────────────────────────────────────────
export const mobileListWrapStyle = { display: 'grid', gap: 8 };
export const mobileEmptyStyle = {
  border: '1px solid var(--border)', borderRadius: 12, background: 'var(--bg-card)',
  padding: 16, textAlign: 'center', color: 'var(--text-muted)', fontSize: 13,
};
/** 상태에 따라 좌측 액센트 바 색상이 달라지는 카드 스타일 */
export const mobileRowStyle = (isLate, isMissingOut) => ({
  border: '1px solid var(--border)',
  borderLeft: isLate ? '3px solid #f59e0b' : isMissingOut ? '3px solid #f87171' : '3px solid var(--border)',
  borderRadius: 12,
  background: isLate ? 'rgba(245,158,11,0.08)' : isMissingOut ? 'rgba(239,68,68,0.08)' : 'var(--bg-card)',
  padding: '12px 14px', display: 'grid', gap: 8,
});
export const mobileTopLineStyle = { display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' };
export const mobileDeptBadgeStyle = { fontSize: 11, fontWeight: 600, background: 'var(--bg-subtle)', color: 'var(--text-sub)', borderRadius: 999, padding: '2px 7px' };
export const mobileDateStyle = { fontSize: 12, color: 'var(--text-muted)' };
export const mobileLateBadgeStyle = { fontSize: 11, fontWeight: 700, background: '#fef3c7', color: '#92400e', border: '1px solid #fcd34d', borderRadius: 999, padding: '2px 7px' };
export const mobileMissingOutBadgeStyle = { fontSize: 11, fontWeight: 700, background: 'rgba(239,68,68,0.15)', color: '#991b1b', border: '1px solid rgba(239,68,68,0.3)', borderRadius: 999, padding: '1px 6px' };
export const mobileTimeLabelStyle = { fontSize: 11, color: 'var(--text-muted)', fontWeight: 500, marginRight: 2 };
export const mobileTimeLineStyle = { display: 'flex', flexWrap: 'wrap', gap: 10, fontSize: 13, color: 'var(--text-sub)' };
export const mobileActionLineStyle = { display: 'flex', gap: 8 };
export const mobileDetailBoxStyle = { border: '1px solid var(--border)', borderRadius: 8, background: 'var(--bg-subtle)', padding: '10px 12px', display: 'grid', gap: 5, fontSize: 13, color: 'var(--text-sub)', overflowWrap: 'anywhere', wordBreak: 'break-all' };
/** 지각 사유 강조 박스 (모바일) — amber 시맨틱 색상, rgba로 다크모드 대응 */
export const mobileLateReasonBoxStyle = { background: 'rgba(245,158,11,0.10)', border: '1px solid #fcd34d', borderRadius: 8, padding: '6px 10px', fontSize: 13, color: '#92400e' };

// ── 데스크탑 테이블 ────────────────────────────────────────────────────────────
export const tableWrapStyle = { overflowX: 'auto', background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 12 };
export const tableStyle = { width: '100%', borderCollapse: 'collapse' };
/** 테이블 헤더 셀 */
export const thStyle = {
  padding: '6px 10px', textAlign: 'left', fontSize: 11, fontWeight: 600,
  color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.04em',
  background: 'var(--bg-subtle)', borderBottom: '2px solid var(--border)', whiteSpace: 'nowrap',
};
/** 테이블 바디 셀 */
export const tdStyle = { padding: '4px 10px', fontSize: 13, color: 'var(--text)', borderBottom: '1px solid var(--bg-subtle)', verticalAlign: 'middle' };
/** 행 배경: 지각=노랑 / 퇴근미체크=빨강 / 기본=카드bg (다크모드 대응 rgba 오버레이) */
export const tableRowStyle = (isLate, isMissingOut) => ({ background: isLate ? 'rgba(245,158,11,0.08)' : isMissingOut ? 'rgba(239,68,68,0.08)' : 'var(--bg-card)', transition: 'background 0.1s' });
/** 빈 행 */
export const emptyTdStyle = { padding: '24px', textAlign: 'center', color: 'var(--text-muted)', fontSize: 13 };

// ── 배지 (Phase 1-2: rgba 15% 다크모드 통일) ─────────────────────────────────
export const lateMinsBadgeStyle = { display: 'inline-block', background: 'rgba(245,158,11,0.15)', color: '#92400e', border: '1px solid rgba(245,158,11,0.3)', borderRadius: 999, padding: '1px 6px', fontSize: 11, fontWeight: 600 };
export const lateReasonTextStyle = { fontSize: 12, color: '#92400e', fontStyle: 'italic' };
export const offdayBadgeStyle = { display: 'inline-block', background: 'rgba(34,197,94,0.15)', color: '#166534', border: '1px solid rgba(34,197,94,0.3)', borderRadius: 999, padding: '1px 6px', fontSize: 11, fontWeight: 600 };
export const ipTextStyle = { display: 'inline-block', maxWidth: 240, overflowWrap: 'anywhere', wordBreak: 'break-all', fontSize: 12, color: 'var(--text-sub)' };

// ── 페이지네이션 ───────────────────────────────────────────────────────────────
export const paginationWrapStyle = { display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 10, marginTop: 4 };

// ── 시간관리 모달 ──────────────────────────────────────────────────────────────
export const timeSettingWrapStyle = { display: 'grid', gap: 10 };
export const timePolicyCardStyle = { border: '1px solid var(--border)', borderRadius: 10, padding: 10, background: 'var(--bg-subtle)', display: 'grid', gap: 8 };
export const timePolicyGridStyle = { display: 'grid', gap: 8, gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))' };
export const timeSettingCardStyle = { border: '1px solid var(--border)', borderRadius: 10, padding: 10, background: 'var(--bg-card)', display: 'grid', gap: 10 };
export const timeSettingHeaderStyle = { display: 'flex', gap: 8, alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap' };
export const timeWeekTableStyle = { display: 'grid', gap: 6 };
export const timeWeekRowStyle = {
  display: 'grid',
  // 요일 | 근무체크 | 근무지 | 출근시간 | ~ | 퇴근시간 | 휴게 | 휴게분 입력 | 반차기준 | 반차시간
  gridTemplateColumns: '32px 68px minmax(88px, 1fr) minmax(70px, 0.8fr) 14px minmax(70px, 0.8fr) 28px minmax(52px, 70px) 52px minmax(60px, 76px)',
  alignItems: 'center', gap: 6,
};
export const timeDayCellStyle = { fontWeight: 700, color: 'var(--text)', textAlign: 'center' };
export const timeWorkdayToggleStyle = { display: 'flex', alignItems: 'center', gap: 8, color: 'var(--text-muted)', fontWeight: 600 };
export const timeWeekInputStyle = { ...inputStyle, width: '100%', minWidth: 0 };
export const timeRangeMarkStyle = { color: 'var(--text-muted)', fontWeight: 700 };
/** 연차 발생 여부 미리보기 박스 (연차O=초록, X=빨강 tint) */
export const annualLeavePreviewStyle = (hasLeave) => ({
  marginTop: 4, padding: '7px 12px', borderRadius: 8, fontSize: 13,
  background: hasLeave ? '#f0fdf4' : '#fef2f2',
  border: `1px solid ${hasLeave ? '#bbf7d0' : '#fecaca'}`,
  color: hasLeave ? '#166534' : '#991b1b',
  display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 4,
});
